import React, { FC, memo, useEffect } from 'react';
import { useAppContext } from '@/hooks/AppContext';
import styles from '@/styles/components/category-bar.module.scss';
import { useRouter } from 'next/router';
import Image from 'next/image';
import classNames from 'classnames';

const CategoryBar: FC<any> = memo((props: any) => {
  const router = useRouter();

  const { setSelectedCategory } = useAppContext();
  const { language, headerAndFooterData } = props;
  // const { categoryList, selectedCategory } = headerAndFooterData;

  const categoryList = headerAndFooterData.blog_menu.menu_item.map((category: any) => ({
    ...category,
    active: false
  }));

  useEffect(() => {
    const urlItemS = window.location.pathname.replace(/^\/|\/$/g, '').split('/');
    if (urlItemS.length === 3) {
      setSelectedCategory(urlItemS[2]);
    }
  }, [setSelectedCategory]);

  const handleGA = (title: any, url: any) => {
    window?.dataLayer?.push({
      event: 'buttonClick',
      buttonTitle: 'blog_menu_bar',
      description: title,
      destinationUrl: url,
      pageURL: window.location.href,
      componentName: 'category bar'
    });
  };

  return (
    <div className={styles.Category_Bar}>
      <div className={styles.Header_Category}>
        {categoryList?.map((item: any, index: any) => {
          const url =
            index === 0 ? `/${language.origin}/blog/` : `/${language.origin}/blog${item?.url}`;
          return (
            <a
              href={url}
              key={index}
              className={classNames(
                styles.Category_Item,
                language.origin === 'zh' ? styles.ZH_Category_Item : ''
              )}
              onClick={() => handleGA(item.label, url)}
            >
              <span
                className={
                  item?.url === `/${router.query.category}/` ||
                  (item?.url === `/guide/` && router.asPath?.includes('/guide'))
                    ? styles.Active
                    : ''
                }
              >
                {item.icon ? (
                  <Image
                    src={item.icon?.url}
                    className={styles.Icon}
                    alt={''}
                    width={15}
                    height={15}
                  />
                ) : (
                  ''
                )}
                {item.label}
              </span>
            </a>
          );
        })}
      </div>
    </div>
  );
});

export default CategoryBar;
